import type { DeepPartial } from '@luna/utils-ts';

import type { LoanFeatureConfig } from '../types/LoanFeatureConfig';

export const loans: DeepPartial<LoanFeatureConfig> = {
    productConfig: {
        preformattedAccountNumber: true,
    },
    overview: {
        enabled: true,
        showAdditionalInfo: true,
        showLoanDisclaimer: true,
        showLoanAmountHighlightRow: true,
        showLoanCurrency: true,
        displayDedicatedMortgageInfos: true,
    },
    additionalDetails: {
        showOverdueInfo: true,
        showExtraInstallment: true,
        lastInstallment: {
            showInstallmentFrequency: true,
        },
    },
    transactions: {
        enabled: true,
        mode: 'flag',
    },
    statements: {
        enabled: true,
        mode: 'flag',
        showMultiDownloadCard: true,
    },
    settingsDetails: {
        displayAccountOwner: true,
        displayLoanIdentifier: true,
    },
};
